import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface RestartApprovalFlowModalProps {
  onSubmit: () => void
  onClose: () => void
}

const RestartApprovalFlowModal = ({ onSubmit, onClose }: RestartApprovalFlowModalProps) => {
  const handleSubmit = () => {
    onClose()
    onSubmit()
  }

  return (
    <Modal
      title={i18n.t('expenses_v2.list.actions.modal.title_reset_flow')}
      description={i18n.t('expenses_v2.list.actions.modal.description_reset_flow')}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('expenses_v2.list.actions.modal.cancel')}
          </Button>
          <Button onClick={handleSubmit}>{i18n.t('expenses_v2.list.actions.modal.reset')}</Button>
        </>
      }
      onClose={onClose}
      illustration="alert"
    />
  )
}

export default RestartApprovalFlowModal
